import React from 'react';
import {Outlet} from 'react-router-dom';

function EditorPage(): JSX.Element {
    return (
        <div className="l-container">
            <Outlet />
        </div>
    );
}

export default EditorPage;
